export const SET_SALES_AND_SERVICE_FILTER = 'SET_SALES_AND_SERVICE_FILTER';
export const SET_SALES_AND_SERVICE_FILTER_OPEN_STATUS = 'SET_SALES_AND_SERVICE_FILTER_OPEN_STATUS';
export const SET_COORDINATES = 'SET_COORDINATES';
export const SET_CURRENT_COORDINATES = 'SET_CURRENT_COORDINATES';
export const SET_BOUNDS = 'SET_BOUNDS';
export const SET_PREVIOUS_PAGE_ID = 'SET_PREVIOUS_PAGE_ID';
export const SET_SEARCH_LOCATION = 'SET_SEARCH_LOCATION';
export const SET_MAIN_CONTACT_POINT = 'SET_MAIN_CONTACT_POINT';
